import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import StationeryReturnNewEditForm from '../stationery-return-new-edit-form';

export default function StationeryReturnCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new return"
        links={[
          {
            name: 'Return',
            href: paths.dashboard.stationeryReturn.root,
          },
          { name: 'Create a new return' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <StationeryReturnNewEditForm />
    </Container>
  );
}
